<template>
  <div class="about">
    <v-container>
    <h1 class="mt-4">Doorprize</h1>
      <div v-if="isLoading">
        <h4>LOADING>>></h4>
      </div>
      <div v-else  >
        <div  v-for="prize in prizes" v-bind:key="prize.id" class="d-inline-flex  mt-4">
          <v-card 
          
          class="ma-8 hover-card"
          elevation="3"
          @click.prevent="handleClick(prize, prize.typePrize)"
          >
          <!-- <h4>{{prize.type}}</h4> -->
              <v-card-actions >
                <div v-if="prize.typePrize === 'dp'" style="max-width: 200px; max-height: 200px;" class="hover-lottie">
                  <lottie-animation
                  ref="anim"
                  :animationData="require('../../assets/lottie-mysterybox.json')"
                  :loop="true"
                  />
                </div>
              </v-card-actions>
            </v-card>
        </div>
        <div >
          <v-card
          class="ma-8 hover-card"
          elevation="3"
          @click.prevent="handleClick(handleClick(getGrandprizes[0].prizes.length, getGrandprizes[0].typePrize))"
          >
          <!-- <h4>{{prize.type}}</h4> -->
              <v-card-actions >
                <div style="width: 200px; max-height: 200px;" class="hover-lottie">
                  <lottie-animation
                  ref="anim"
                  :animationData="require('../../assets/lottie-kado2.json')"
                  :loop="true"
                  style="width: 200px;"
                  />
                </div>
              </v-card-actions>
            </v-card>
        </div>
          <!-- <v-card 
          v-for="(item, idx) in getGrandprizeOnly" v-bind:key="item.id"
          class="ma-2 hover-card"
          elevation="3"
          @click.prevent="handleClick(item, idx)"
          >
            <v-card-actions >
              <div style="max-width: 96px; max-height: 96px;" class="hover-lottie">
                <lottie-animation
                ref="anim"
                :animationData="require('../../assets/lottie-mysterybox.json')"
                :loop="true"
                />
              </div>
            </v-card-actions>
          </v-card> -->
        </div>
    </v-container>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import LottieAnimation from 'lottie-web-vue'

export default {
  components: {
    LottieAnimation
  },
  computed: {
    ...mapState({
      prizes: state => state.doorprizes.prizes.slice(0,4)
    }),
    ...mapGetters(['isLoading', 'getGrandprizeName', 'getGrandprizes'])
  },
  created() { 
      this.$store.dispatch('fetchPrizes')
      this.$store.dispatch('getGrandprize')
    // console.log(this.prizes, "<< state dapet")
  },
  methods: {
    fetchFromLocal() {
      this.$store.dispatch('fetchFromLocalStorage')
    },
    handleClick(prize, type) {
      console.log( this.grandprizes, "< clicked item");
      if (type === 'dp') {
        this.$store.commit("SET_DOORPRIZE_DATA", prize)
        // console.log(prize.jumlah, "<< ini doorprize")
        this.$router.push({name: 'SlotDoorprize', params: {id: type, items: prize}})
      } else {
         this.$router.push({name: 'Spin', params: {id: 1, items: prize}})
      }
      // this.$router.push('/admin/spin/'+prize)
    },
    checkState() {
      // console.log(this.getGrandprizes, "<< prize dapety")
    }
  }
}
</script>

<style>
  .hover-card {
    transition: background-color 0.5s ease;
  }
  .hover-card:hover {
    background-color: rgb(219, 219, 219);;
  }

  .hover-lottie {
    transition: all .2s ease-in-out;
  }
  .hover-lottie:hover {
    transform: scale(1.6);
  }
</style>
